import React from 'react';

import './Loader.css';

export default () =>
  <div className="la la-line-scale-pulse-out-rapid la-dark">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>;
